import VideoPlayer from 'components/shared/video/video';
import classNames from 'classnames';
import { Fragment } from 'react';
import styles from './mediaPortrait.module.scss';
import Image from '../../shared/image';

const MeidaSection = ({ data }) => {
  const { media, header, alignment, anchorId } = data;

  return (
    <section id={anchorId} className={styles.section}>
      {header && <h2 className={styles.header}>{header}</h2>}
      <div className={styles.container} style={{ '--alignment': alignment || 'center' }}>
        {media.map(item => (
          <Fragment key={`MeidaSectionBanner-${item.id}`}>
            {item.type === 'Image' && (
              <Image
                className={classNames(styles.media, styles.imageMedia)}
                src={item.image}
                loading="eager"
                layout="fill"
                sizes="50vw"
              />
            )}
            {item.type === 'Video' && item.video && (
              <VideoPlayer
                className={styles.media}
                thumbnail={item.thumbnail}
                source={item.video}
                aspectRatio={item.videoAspectRatio}
                objectFit={item.objectFit}
                controlsVersion={2}
                focalPoint={item.focalPoint}
              />
            )}
          </Fragment>
        ))}
      </div>
    </section>
  );
};

export default MeidaSection;
